import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import {
  CampaignSegmentsAPIResponse,
  CampaignSegmentsModelView,
} from '~/types';

export const GET_SEGMENTS_QUERY_KEY = 'GET_SEGMENTS_QUERY';

function getSegments() {
  return serviceApi.get<CampaignSegmentsAPIResponse>('/Segmentacao', {
    params: {
      projectAdsId: 2,
    },
  });
}

export function useGetSegments() {
  return useQuery({
    queryKey: [GET_SEGMENTS_QUERY_KEY],
    queryFn: getSegments,
    select: data => {
      // Transform API response keys to match frontend expectations
      const apiData = data.data;
      const transformedData: CampaignSegmentsModelView = {
        estado: apiData.estado || [],
        canaisMidia: apiData.canais || [],
        categorias: apiData.categoria || [],
      };
      return transformedData;
    },
  });
}
